import modelFieldMessages from '../modelFieldMessages';

export const qualityChoices = {
  1: modelFieldMessages.mlQuality,
  0: modelFieldMessages.dlQuality
};

export const orientationChoices = {
  3: modelFieldMessages.KVHPackageType,
  2: modelFieldMessages.qPackageType,
  1: modelFieldMessages.lPackageType
};

export const rotationChoices = {
  // 2: modelFieldMessages.altRotation,
  1: modelFieldMessages.upRotation,
  0: modelFieldMessages.downRotation
};

export const exitChoices = {
  1: modelFieldMessages.kallesoe,
  2: modelFieldMessages.exit
};

export const wiehag_config = {
  qualityChoices,
  orientationChoices,
  rotationChoices,
  exitChoices
};

export default wiehag_config;
